/**
 * Filtro do seletor de clientes (troca de conta na barra lateral).
 *
 * A lista inteira já chega carregada de `GET /internal/companies` — que devolve
 * os campos escalares de `ClientAccount`, `cnpj` incluso — então a busca é local:
 * sem request, sem debounce, sem paginação.
 */

/**
 * Um CNPJ de um ou dois dígitos casa com boa parte da base e transformaria a
 * lista em ruído. Abaixo deste piso, a busca considera apenas a razão social.
 */
const MIN_CNPJ_DIGITS = 3;

/** @param {unknown} value @returns {string} */
function onlyDigits(value) {
    return String(value ?? "").replace(/\D/g, "");
}

/**
 * Decide se uma conta atende ao termo buscado — por razão social ou por CNPJ.
 *
 * Os dois lados da comparação de CNPJ são reduzidos a dígitos. Hoje a coluna
 * guarda apenas dígitos, mas quem busca cola o número formatado ("12.345.678/
 * 0001-90"): sem normalizar o que foi digitado, a busca não acha nada e parece
 * quebrada. Normalizar o lado armazenado também é de graça e protege o dia em
 * que uma linha entrar formatada.
 *
 * @param {{companyName?: string, cnpj?: string}} company
 * @param {string} query - termo cru do input
 * @returns {boolean}
 */
export function matchesCompanyQuery(company, query) {
    const term = String(query ?? "")
        .trim()
        .toLowerCase();

    if (!term) return true;

    if (company?.companyName?.toLowerCase().includes(term)) return true;

    const digits = onlyDigits(term);
    if (digits.length < MIN_CNPJ_DIGITS) return false;

    return onlyDigits(company?.cnpj).includes(digits);
}

export default { matchesCompanyQuery };
